import { UIOfferHeroSection } from 'interfaces/ui/ui-offer-hero-section';
import { Element } from 'react-scroll';
import HeroCompany from './HeroCompany';
import HeroInfo from './HeroInfo';
import {
  StyledHeroContainer,
  StyledHeroSection,
  StyledHeroSectionBg
} from './HeroSection.styled';

type HeroSectionProps = UIOfferHeroSection & {
  onlyAvailableInLang: string | null;
};

const HeroSection: React.FC<HeroSectionProps> = (props) => {
  return (
    <Element name="inicio" id="hero">
      <StyledHeroSection>
        <StyledHeroSectionBg bgImage={props.companyPhoto}>
          <div></div>
        </StyledHeroSectionBg>
        <StyledHeroContainer>
          <HeroCompany {...props} />
          <HeroInfo {...props} />
        </StyledHeroContainer>
      </StyledHeroSection>
    </Element>
  );
};

export default HeroSection;
